<script lang="ts" setup>
import { PhCalendarBlank } from '@phosphor-icons/vue';
export type StateInputMode = 'edit' | 'read-only' | 'hidden';

defineOptions({ inheritAttrs: false });

const props = withDefaults(
  defineProps<{
    mode?: StateInputMode;
    type?: string;
    modelValue?: string;
    readonlyClass?: string | Record<string, boolean> | string[];
  }>(),
  {
    mode: 'read-only',
    type: 'text',
    modelValue: '',
  },
);

const emit = defineEmits<{
  'update:modelValue': [value: string];
}>();
</script>

<template>
  <span
    v-if="props.type === 'date' && props.mode === 'edit'"
    class="date-edit-field"
  >
    <input
      v-bind="$attrs"
      type="text"
      :value="props.modelValue"
      @change="
        emit('update:modelValue', ($event.target as HTMLInputElement).value)
      "
    />
    <span class="date-picker-icon">
      <PhCalendarBlank :size="14" />
      <input
        type="date"
        class="date-picker-overlay"
        :value="props.modelValue"
        @change="
          emit('update:modelValue', ($event.target as HTMLInputElement).value)
        "
      />
    </span>
  </span>

  <input
    v-else-if="props.mode === 'edit'"
    v-bind="$attrs"
    :type="props.type"
    :value="props.modelValue"
    @change="
      emit('update:modelValue', ($event.target as HTMLInputElement).value)
    "
  />

  <span v-else-if="props.mode === 'read-only'" :class="props.readonlyClass">{{
    props.modelValue
  }}</span>
</template>

<style scoped>
.date-edit-field {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  width: 100%;
}

.date-edit-field > input {
  flex: 1;
  min-width: 0;
  background: transparent;
  border: none;
  box-shadow: inset 0 -1px 0 #aaa;
  outline: none;
  padding: 0;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  color: inherit;
  transition: box-shadow 0.15s;
}

.date-edit-field > input:hover {
  box-shadow: inset 0 -1px 0 #666;
}

.date-edit-field > input:focus {
  box-shadow: inset 0 -1px 0 var(--primary-color);
}

.date-edit-field > input::placeholder {
  color: #bbb;
}

.date-picker-icon {
  position: relative;
  display: inline-flex;
  align-items: center;
  color: #222;
  cursor: pointer;
}

.date-picker-icon:hover {
  color: var(--primary-color);
}

.date-picker-overlay {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  padding: 0;
  margin: 0;
  border: none;
}
</style>
